import classNames from "classnames";
import { GatsbyImage } from "gatsby-plugin-image";
import React from "react";
import { CollectionProps } from "./Collection";
export const List: React.FC<CollectionProps> = (props) => {
  const { title, image, alt, shape, contents, className } = props;
  return (
    <section
      data-component="List"
      className={classNames("py-100px", "lg:py-150px", "relative", className)}
    >
      <div className="page-grid max-width relative">
        {shape && (
          <img
            className={classNames(
              "col-span-6 col-start-1 row-span-2 row-start-1",
              "lg:col-span-7 lg:col-start-1 lg:row-span-2 lg:row-start-1",
              "object-contain",
            )}
            src={shape.encoded ?? shape.encodedUrl}
            alt=""
          />
        )}
        {image && (
          <GatsbyImage
            image={image}
            alt={alt ?? title ?? "Image"}
            className={classNames(
              "col-span-6 col-start-1 row-span-2 row-start-1",
              "lg:col-span-7 lg:col-start-1 lg:row-span-2 lg:row-start-1",
            )}
            objectFit="contain"
            loading="lazy"
          />
        )}
        {title && (
          <h2
            className={classNames(
              "h2 relative",
              "col-span-3 col-start-2",
              "lg:col-span-4 lg:col-start-3",
              "row-span-1 row-start-1 self-start",
            )}
          >
            {title}
          </h2>
        )}
        <ul
          className={classNames(
            "mt-60px",
            "lg:mt-0",
            "relative",
            "col-span-3 col-start-3 row-start-2",
            "md:col-span-6 md:col-start-4",
            "lg:col-span-7 lg:col-start-8 lg:row-span-1 lg:row-start-1",
            "lg:grid lg:grid-cols-7 lg:gap-x-desktop",
          )}
        >
          {contents?.map(({ content }, i) => {
            return (
              <li
                key={content.key}
                className={classNames(
                  "lg:col-span-3",
                  i % 2 != 0 ? "lg:col-start-5" : "",
                )}
              >
                {content}
              </li>
            );
          })}
        </ul>
      </div>{" "}
    </section>
  );
};
